import { render, staticRenderFns } from "./ApprovalComplete.vue?vue&type=template&id=5312e8ea&scoped=true&"
import script from "./ApprovalComplete.vue?vue&type=script&lang=js&"
export * from "./ApprovalComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5312e8ea",
  null
  
)

export default component.exports